module.exports = __webpack_public_path__ + "img/a3.1f0a45c5.png";